import request from '@/utils/axios';

// 查询 有block api的数据
export const getApiContain = (str: string) => {
    return request.get(`${str}`);
};
